// FloatingInputLabel.js
import React from "react";
import PropTypes from "prop-types";
import styles from "./FloatingInputLabel.scss";

const FloatingInputLabel = function TextInput({
   type = "text",
   label,
   onKeyUp, // Updated prop name
   onChange,
   className = "input-container",
   disabled = false,
   name, // Added name prop for accessibility
   value, // Controlled component value
}) {
   // Remove internal state to make it a controlled component
   // const [value, setValue] = useState("");

   function onHandleChange(e) {
      onChange(e);
      // setValue(e.target.value); // Removed to prevent state conflict
   }

   function onHandleKeyUp(e) {
      if (typeof onKeyUp === 'function') {
         onKeyUp(e);
      }
   }

   return (
      <div className={className}>
         <input
            type={type}
            value={value}
            onChange={onHandleChange}
            onKeyUp={onHandleKeyUp}
            disabled={disabled}
            name={name} // Added name for label association
            className="form-control" // Added class for styling
         />
         <label className={value ? "filled" : ""} htmlFor={name}>
            {label}
         </label>
      </div>
   );
};

FloatingInputLabel.propTypes = {
   type: PropTypes.string,
   label: PropTypes.string.isRequired,
   onKeyUp: PropTypes.func, // Updated prop type
   onChange: PropTypes.func.isRequired,
   className: PropTypes.string,
   disabled: PropTypes.bool,
   name: PropTypes.string.isRequired, // Added name prop type
   value: PropTypes.string.isRequired, // Controlled component value
};

export default FloatingInputLabel;
